export default __webpack_public_path__ + "static/media/driver.623c7436.png";